module.exports = __webpack_public_path__ + "static/media/speaker-terrence-mobile.38caaf34.jpg";